import { Cae } from './Cae';
import { Comprobante } from './Comprobante';
import { Nota } from './Nota';
import {Renglon} from './Renglon';
import { ComprobanteEncabezado } from './ComprobanteEncabezado';
import { ImpuestoPercepcion } from './ImpuestoPercepcion';
import { PagoContado } from './PagoContado';
import { Leyenda } from './Leyenda';
import { PagoElectronicoDto } from './PagoElectronicoDto';
export class Factura extends Comprobante {

  id: string // necesario cuando se tiene que mandar una lista de ids
  condicionVenta: number;
  cae: Cae;
  estado: number;
  netoTotal: number;
  subtotal: number;
  total: number;
  codigoBarras: string;
  remitos: ComprobanteEncabezado[];
  nota: Nota;
  renglones: Renglon[];
  impuestos: ImpuestoPercepcion[];
  percepciones: ImpuestoPercepcion[];
  pago: PagoContado[];
  pagosElectronicos: PagoElectronicoDto[];
  numerosAerovales: string;
  patentes: string;
  ciudadAeroplanta: string;
  leyendas: Leyenda[];
  codigoQr: string;
  cotizacionMoneda: number;
  ranchos: string;
  linkPDFOriginal: string;
}
